const music = {
  title: "Sunflower",
  artist: "Post Malone / Swae Lee",
  cover: "//p1.music.126.net/z0IO1vEsowL9mD_5yzUjeA==/109951163936068098.jpg",
  audio: "music/sunflower.mp3",
};

export default music;
